module.exports = __webpack_public_path__ + "img/5.4efb1b37.jpg";